import React from 'react'
import { useTranslation } from 'react-i18next'
import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { CustomCellRendererProps } from 'ag-grid-react'
import {
  FlexCellContent,
  TruncatableText,
  NoShrinkContainer
} from '../../../../shared/components/custom/Grid/cellRenderers/CellComponents'
import { StatementRow } from '../../../../types/statementRow/StatementRow'

export interface AccountMapGridContext {
  validationErrors: boolean
  statementRowsById: Map<number, StatementRow>
  getStatementRowName: (statementRowId: number) => string
  editable: boolean
  onAddRow: (statementRowId: number) => void
}

const StatementRowGroupCell: React.FC<CustomCellRendererProps> = ({ node, value, context }) => {
  const { t } = useTranslation()
  const { statementRowsById, getStatementRowName, editable, onAddRow } = context as AccountMapGridContext

  if (!node.group) return null

  const statementRowId = Number(value)
  if (Number.isNaN(statementRowId)) return null

  const statementRow = statementRowsById.get(statementRowId)
  const isParentRow = statementRow?.isParent ?? false
  const name = getStatementRowName(statementRowId)

  return (
    <FlexCellContent style={{ width: '100%' }}>
      <TruncatableText style={isParentRow ? { fontWeight: 'bold' } : undefined}>{name}</TruncatableText>
      {editable && !isParentRow && (
        <NoShrinkContainer>
          <Button
            type="text"
            size="small"
            title={t('customReportPage:add-row')}
            icon={<PlusOutlined />}
            onClick={e => {
              e.stopPropagation()
              onAddRow(statementRowId)
            }}
            onDoubleClick={e => e.stopPropagation()}
          />
        </NoShrinkContainer>
      )}
    </FlexCellContent>
  )
}

export default StatementRowGroupCell
